import React, { Component } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import './Focus.scss';

class Focus extends Component {

  constructor(props) {
    super(props);

    this.state = {
      image: props.image,
      info: props.info
    }
  }

  render() {
    return (
      <div className="Focus" onClick={this.props.removeFocus}>
        <button className="Focus-button" onClick={this.props.removeFocus}>
          <svg className="Focus-button-icon" width="25" height="25">
            <line x1="0" x2="25" y1="0" y2="25"></line>
            <line x1="25" x2="0" y1="0" y2="25"></line>
          </svg>
        </button>

        <ReactCSSTransitionGroup className="Focus-image-group"
                                 transitionName="example"
                                 transitionAppear={true}
                                 transitionAppearTimeout={255}
                                 transitionLeaveTimeout={255}
                                 transitionEnterTimeout={255}>
          <img className="Focus-image" src={this.state.image} alt=""
               key={this.state.image} ></img>
        </ReactCSSTransitionGroup>

      </div>
    )
  }
}


export default Focus;
